import { Box, IconButton, Typography, Paper } from '@mui/material';
import { CallEnd, Phone } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { useVoIP } from '../hooks/useVoIP';
import { useCallTimer } from '../hooks/useCallTimer';
import { CallState } from '../types';

export const DialerMinimized = () => {
  const { t } = useTranslation();
  const { callState, currentCall, hangUp, answerCall, maximizeDialer } = useVoIP();

  const duration = useCallTimer(currentCall?.startTime, callState === CallState.CONNECTED);

  const getDisplayText = () => {
    if (callState === CallState.INCOMING) return t('voip.incoming_call');
    if (callState === CallState.CONNECTED) return duration;
    if (callState === CallState.OUTGOING) return t('voip.calling');
    return t('voip.unknown');
  };

  return (
    <Paper
      elevation={8}
      sx={{
        position: 'fixed',
        bottom: 16,
        right: 16,
        zIndex: 9999,
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        p: 1.5,
        bgcolor: callState === CallState.INCOMING ? 'success.light' : 'primary.main',
        color: 'white',
        cursor: 'pointer',
        minWidth: 200,
        animation: callState === CallState.INCOMING ? 'pulse 1.5s infinite' : 'none',
        '@keyframes pulse': {
          '0%, 100%': { opacity: 1 },
          '50%': { opacity: 0.7 },
        },
      }}
      onClick={maximizeDialer}
    >
      <Box sx={{ flex: 1 }}>
        <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
          {currentCall?.contactInfo?.name || currentCall?.phoneNumber}
        </Typography>
        <Typography variant="caption">{getDisplayText()}</Typography>
      </Box>

      {callState === CallState.INCOMING ? (
        <IconButton
          size="small"
          onClick={(e) => {
            e.stopPropagation();
            answerCall();
          }}
          sx={{ color: 'white' }}
        >
          <Phone />
        </IconButton>
      ) : null}

      <IconButton
        size="small"
        onClick={(e) => {
          e.stopPropagation();
          hangUp();
        }}
        sx={{ color: 'white' }}
      >
        <CallEnd />
      </IconButton>
    </Paper>
  );
};
